import { useCallback } from 'react';

import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

import { ActiveFilter } from '../Filter.types';

export const useIsAcademicFilterDisabled = () => {
  const { showOnlyAllAcademicFilterOption } = useAccessibleAccounts();

  const getIsFilterDisabled = useCallback(
    (filterName: ActiveFilter): boolean => {
      const isAcademicYearField = filterName === 'academicYear';

      return isAcademicYearField && showOnlyAllAcademicFilterOption;
    },
    [showOnlyAllAcademicFilterOption]
  );

  return { getIsFilterDisabled };
};
